<style>
	:global(body.dark-mode) .footer {
		background-color: #161b22;
        padding: 2rem 1.5rem 2rem;
	}
    :global(body.dark-mode) .content {
        color: white;
    }
</style>

<footer class="footer">
    <div class="content has-text-centered">
       <p>Made with ❤️ (by <a href="https://github.com/Olyno">Olyno</a>)</p>
    </div>
</footer>